<template>
  <div class="float-right">
    <el-button
      type="primary"
      class="btn-main"
      icon="el-icon-search"
      @click="dialog = true"
    >
      Filters
    </el-button>
    <el-dialog
      title="Filters"
      :visible.sync="dialog"
      width="500px"
      top="3vh"
      :modal="false"
    >
      <el-input
        type="text"
        v-model="title"
        placeholder="Title"
        clearable
        @clear="filter()"
        @keyup.native.enter="filter()"
      />
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      title: ''
    }
  },
  methods: {
    ...mapActions('track', ['read']),

    filter() {
      let filter_data = {
        title: this.title
      }
      localStorage.setItem('tracks_filter', JSON.stringify(filter_data))
      this.read()
    },

    clear() {
      this.read()
      this.title = ''
      this.dialog = false
      localStorage.removeItem('tracks_filter');
    }
  }
}
</script>
